<template>
    <div class="canvas-host" :class="wrapClass">
        <canvas ref="canvasEl" />
    </div>
</template>

<script setup>
import { nextTick, onBeforeUnmount, onMounted, ref, watch } from "vue";
import { createBarChart } from "../../helpers/dashboardChartFactory";
import { mergeBarChartOptions } from "../../helpers/dashboardChartBarOptions";

const props = defineProps({
    labels: {
        type: Array,
        default: () => [],
    },
    datasets: {
        type: Array,
        default: () => [],
    },
    extraOptions: {
        type: Object,
        default: () => ({}),
    },
    wrapClass: {
        type: String,
        default: "",
    },
});

const canvasEl = ref(null);
let chartInstance = null;

async function draw() {
    if (chartInstance) {
        chartInstance.destroy();
        chartInstance = null;
    }
    await nextTick();
    if (!canvasEl.value || !props.labels?.length || !props.datasets?.length) {
        return;
    }
    chartInstance = createBarChart(
        canvasEl.value,
        { labels: props.labels, datasets: props.datasets },
        mergeBarChartOptions(props.extraOptions),
    );
}

watch(
    () => [props.labels, props.datasets, props.extraOptions],
    () => {
        draw();
    },
    { deep: true },
);

onMounted(() => {
    draw();
});

onBeforeUnmount(() => {
    if (chartInstance) {
        chartInstance.destroy();
        chartInstance = null;
    }
});
</script>

<style scoped lang="scss">
.canvas-host {
    position: relative;
    width: 100%;
    min-width: 0;
    height: 290px;
}

.canvas-host.compact {
    height: 240px;
}
</style>
